import { render, staticRenderFns } from "./AutomationWizardPanel.vue?vue&type=template&id=5c646fb4&scoped=true&"
import script from "./AutomationWizardPanel.vue?vue&type=script&lang=js&"
export * from "./AutomationWizardPanel.vue?vue&type=script&lang=js&"
import style0 from "./AutomationWizardPanel.vue?vue&type=style&index=0&id=5c646fb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c646fb4",
  null
  
)

export default component.exports